import { MetaApp, MetaAttributes } from '@grafana/faro-web-sdk';
import { BeforeSendEvent } from 'src/types';

export const isJsLogEvent = (event: BeforeSendEvent) => {
  return Boolean(event.payload.context?.jsEventLog && event.payload.context?.app);
};

export const mutateJsLogBeforeSend = (event: BeforeSendEvent): BeforeSendEvent => {
  const { app, jsEventLog } = event.payload.context;
  if (jsEventLog) {
    const parsedApp: MetaApp = JSON.parse(app);
    event.meta.app = parsedApp;
    delete event.payload.context.app;
  }
  return event;
};

export const mutateSessionBeforeSend = (event: BeforeSendEvent, sessionContext: MetaAttributes): BeforeSendEvent => {
  const { session } = event.meta;
  const updatedSession = {
    ...session,
    attributes: {
      ...session.attributes,
      ...sessionContext
    }
  };

  return {
    ...event,
    meta: {
      ...event.meta,
      session: updatedSession
    }
  };
};

// This is the last stop before the log is sent to the remote service.
// If the log is sent from a JS event, the app object is updated to match
// the component that called the JS event.
export const beforeSend = (event: BeforeSendEvent, sessionContext?: MetaAttributes): BeforeSendEvent => {
  let updatedEvent = event;

  if (isJsLogEvent(updatedEvent)) {
    updatedEvent = mutateJsLogBeforeSend(updatedEvent);
  }

  if (!isJsLogEvent(updatedEvent)) {
    updatedEvent = mutateSessionBeforeSend(updatedEvent, sessionContext ?? {});
  }

  return updatedEvent;
};
